const api = {
  // 'baseUrl': 'http://localhost/',
  'baseUrl': 'https://api.manage.tsyungu.com/',
  'imgUpload': 'imgupload',
  'videoUpload': 'videoupload',
  'setBrainReserve': 'setbrainreserve',
  'setBrainReserve2': 'setbrainreserve2',
  'setBrainReserve3': 'setbrainreserve3',
  'getUserInfo': 'getuserinfo',
  'setNcpOrder': 'setncporder',
  'getConfig': 'getconfig',
  'getWxPayData': 'getwxpaydata',
  'getNcpOrder': 'getncporder',
  'idImgUpload': 'idimgupload',
  'fileImgUpload': 'fileimgupload',
  'confirm': 'confirm',
  'rescueIdImgUpload': 'rescueidimgupload',
  'errLog': 'errlog',
  'checkBackend': 'admin/checkbackend',
  'login': 'admin/login',
  'interview': 'interview',
  'getopenid': 'getopenid',
  'getInfo': 'getinfo',
  'improve': 'improve',
  'brain4submit': 'brain4submit',
  'brain5submit': 'brain5submit',
  'getInfoSup': 'getinfosup',
  'supSubmit': 'supsubmit',
  'supPicUpload': 'suppicupload',
  'supVideoUpload': 'supvideoupload',
  'brain6submit': 'brain6submit'
};
export default api;
